import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Modal } from '../../../../../../../molecules'
import { IProposalInteractionsProps } from '../../../../../../../organisms/proposal/Proposal'

interface IOwnerCanModifyAdjustmentsModalProps {
  ownerActions: IProposalInteractionsProps['ownerActions']
  isOpenModal: boolean
  setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  clientProposalId: string
}

const OwnerCanAskAdjustmentsModificationModal = ({
  ownerActions,
  isOpenModal,
  setIsOpenModal,
  clientProposalId,
}: IOwnerCanModifyAdjustmentsModalProps) => {
  const intl = useIntl()
  const [message, setMessage] = useState('')

  if (!ownerActions) {
    return null
  }

  return (
    <Modal
      isOpen={isOpenModal}
      closeModal={() => setIsOpenModal(false)}
      title={intl.formatMessage({
        id: 'ui.OwnerCanAskAdjustmentsModificationModal.modalTitle',
        defaultMessage: 'Modifier les ajustements',
      })}
      scrollbarStyle={{ padding: '20px 30px' }}
      footerStyle={{ boxSizing: 'border-box' }}
      className='w-[550px]'
      footer={{
        button: {
          label: intl.formatMessage({
            id: 'ui.OwnerCanAskAdjustmentsModificationModal.contactAdvisor',
            defaultMessage: 'Contacter un conseiller Naboo',
          }),
          fullWidth: true,
          onClick: async () => {
            await ownerActions.ownerAskedAdjustmentsModification.callback({
              clientProposalId,
              message: message,
            })
            setIsOpenModal(false)
          },
          isLoading: ownerActions.ownerAskedAdjustmentsModification.isLoading,
        },
      }}
    >
      <div className='flex flex-col gap-4 text-sm'>
        <p>
          <FormattedMessage
            id='ui.OwnerCanAskAdjustmentsModificationModal.modifyAdjustments'
            defaultMessage='Vous souhaitez modifier les ajustements ?'
          />
        </p>
        <p>
          <FormattedMessage
            id='ui.OwnerCanAskAdjustmentsModificationModal.explainModifications'
            defaultMessage='Décrivez en quelques mots les corrections à effectuer sur les ajustements puis cliquez sur le bouton
          ci-dessous afin d’avertir un conseiller Naboo qui vous recontacte dans les 24h.'
          />
        </p>
        <p className=''>
          <FormattedMessage
            id='ui.OwnerCanAskAdjustmentsModificationModal.modificationsToMake'
            defaultMessage='Modifications à effectuer sur les ajustements'
          />
        </p>
        <textarea
          className='min-h-32 rounded-lg border border-grey-500 p-3 focus:outline-none'
          onChange={(e) => setMessage(e.target.value)}
          placeholder={intl.formatMessage({
            id: 'ui.OwnerCanAskAdjustmentsModificationModal.writeHere',
            defaultMessage: 'Écrire ici',
          })}
        />
      </div>
    </Modal>
  )
}

export default OwnerCanAskAdjustmentsModificationModal
